import * as React from 'react'
import * as moment from 'moment'
import * as RouteClasses from '../../../Socket/route-classes'
import * as Assets from '../../../assets/Assets'
import Socket from '../../../Socket/socket-init'
// import SocketState from '../../../Socket/socketstate'
import * as Utils from '../../../Logic/Utils'
import { Main } from '../../../Logic/Main'
import { Logic } from '../../../Logic/Type'
// import * as Results from './Results'
import * as Body from './Body'
import { Link, Redirect } from 'react-router-dom'
import { Cookies, withCookies } from 'react-cookie'
import Loader from './Loader'

const logos: any = [
    {teamName: 'Liverpool', src: 'liverpool-shirt.png'},
    {teamName: 'Stoke', src: 'stoke-shirt.png'},
    {teamName: 'Burnley', src: 'burnley-shirt.png'},
    {teamName: 'Brighton', src: 'middlesbrough-shirt.png'},
    {teamName: 'Crystal Palace', src: 'crystal-palace-shirt.png'},
    {teamName: 'Leicester', src: 'leicester-shirt.png'},
    {teamName: 'Huddersfield', src: 'sunderland-shirt.png'},
    {teamName: 'Everton', src: 'everton-shirt.png'},
    {teamName: 'Newcastle', src: 'hull-shirt.png'},
    {teamName: 'West Brom', src: 'west-brom-shirt.png'},
    {teamName: 'Southampton', src: 'southampton-shirt.png'},
    {teamName: 'Bournemouth', src: 'bournemouth-shirt.png'},
    {teamName: 'Swansea', src: 'swansea-shirt.png'},
    {teamName: 'Chelsea', src: 'chelsea-shirt.png'},
    {teamName: 'West Ham', src: 'west-ham-shirt.png'},
    {teamName: 'Man City', src: 'manchester-city-shirt.png'},
    {teamName: 'Man Utd', src: 'manchester-united-shirt.png'},
    {teamName: 'Manchester City', src: 'manchester-city-shirt.png'},
    {teamName: 'Manchester United', src: 'manchester-united-shirt.png'},
    {teamName: 'Tottenham', src: 'tottenham-shirt.png'},
    {teamName: 'Watford', src: 'watford-shirt.png'}
]

export function getLogo(teamName: string) {
    for (const logo of logos) {
        if (logo.teamName === teamName) return logo.src
    }
}

function setVisible(i: number, homeAway?: number, closeAll?: boolean) {
    const matches = Socket.Get<any>('matches')

    if (closeAll) {
        for (const match of matches.matches) {
            match.open = false
        }
    } else {
        matches.matches[i].open = !matches.matches[i].open
    }
    
    if (homeAway) {
        for (const match of matches.matches) {
            match.open = false
        }
        matches.matches[i].open = !matches.matches[i].open
        if (matches.matches[i].homeAway === 1 && homeAway === 1) matches.matches[i].homeAway = 0
        else if (matches.matches[i].homeAway === 2 && homeAway === 2) matches.matches[i].homeAway = 0
        else matches.matches[i].homeAway = homeAway
        
        if (matches.matches[i].homeAway === 0) matches.matches[i].open = !matches.matches[i].open
    }
    Socket.Set('matches', matches)
}


function checkNumber(type: string): string {
    switch (type) {
        case 'correctScores':
            if (Main.Instance.Fantasy.chosenResults.correctScores.length === 1) {
                return '1 match (required 3).'
            } else {
                return Main.Instance.Fantasy.chosenResults.correctScores.length.toString() + ' matches (required 3).'
            }
        case 'accumulator':
            if (Main.Instance.Fantasy.chosenResults.accumulator.length === 1) {
                return '1 match (required 3).'
            } else {
                return Main.Instance.Fantasy.chosenResults.accumulator.length.toString() + ' matches (required 3).'
            }
        case 'goalscorers':
            if (Main.Instance.Fantasy.chosenResults.goalscorers.length === 1) {
                return '1 goalscorer (required 3).'
            } else {
                return Main.Instance.Fantasy.chosenResults.goalscorers.length.toString() + ' goalscorers (required 3).'
            }
        default:
            return ''
    }
}

function updateBet(playerId: number) {
    const bet: RouteClasses.IBet = {
        playerId: +playerId,
        round: +localStorage.getItem('roundId'),
        correctScores: Main.Instance.Fantasy.chosenResults.correctScores,
        accumulator: Main.Instance.Fantasy.chosenResults.accumulator,
        goalscorers: Main.Instance.Fantasy.chosenResults.goalscorers
    }
    Socket.Send('update-bet', bet)
}

interface IState1 {
    userDropdown: boolean
    popup: boolean
    team: string
    homeAway: number
    mobileMenu: boolean
    checkPoints: boolean
    allMatches: boolean
    homeDrawAway: number[]
}

export class Bet1 extends React.Component<{location: {state: any}}, IState1> {
    public cookies

    constructor (props) {
        super(props)

        window.scroll(0, 0)

        window.onload = () => {
            Socket.Send('matches', {round: +localStorage.getItem('roundId')})
            Logic.Type.New(Main.Instance.Fantasy, {chosenResults: JSON.parse(localStorage.getItem('chosenResults'))})
            if (JSON.parse(localStorage.getItem('selectedResult')) === null) {
                Logic.Type.New(Main.Instance.Fantasy, {selectedResult: ['---', '---', '---', '---', '---', '---', '---', '---', '---' ,'---']})
            } else {
                Logic.Type.New(Main.Instance.Fantasy, {selectedResult: JSON.parse(localStorage.getItem('selectedResult'))})
            }
            if (JSON.parse(localStorage.getItem('selectedAcc')) === null) {
                Logic.Type.New(Main.Instance.Fantasy, {selectedAcc: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]})
            } else {
                Logic.Type.New(Main.Instance.Fantasy, {selectedAcc: JSON.parse(localStorage.getItem('selectedAcc'))})
            }
        }

        this.cookies = new Cookies()

        this.state = {
            userDropdown: false,
            popup: false,
            team: '',
            homeAway: 0,
            mobileMenu: false,
            checkPoints: false,
            allMatches: false,
            homeDrawAway: (screen.width > 768) ? [4, 4, 4, 4, 4, 4, 4, 4, 4, 4] : [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }

        Socket.Send('matches', {round: +localStorage.getItem('roundId')})
        Socket.Send('flags', {})
    }

    render() {
        if (Socket.Get<any>('matches').loading !== 'loaded' || Socket.Get<any>('flags').loading !== 'loaded') {
            return <Loader/>
        } else {
            const possibleTotal: any = this.calculatePossibleTotal(Main.Instance.Fantasy.chosenResults)
            return (
                <section className="wrapper">
                    <div className="header" role="banner">
                        <header className="navbar navbar-default" style={{ marginBottom: '0' }}>
                            <div className="container">
                                <div className="navbar-header">
                                    <button 
                                        onClick={() => this.setState({ mobileMenu: !this.state.mobileMenu })}
                                        type="button" 
                                        className={(this.state.mobileMenu) ? 'navbar-toggle navbar-mid-toggle' : 'navbar-toggle navbar-mid-toggle collapsed'} 
                                        data-toggle="collapse" 
                                        data-target="#navbar-collapse-mid" 
                                        aria-expanded={(this.state.mobileMenu) ? 'true' : 'false'}
                                    >
                                    <span className="sr-only">Toggle navigation</span>
                                    <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                                    <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                                    <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                                    </button>                                  
                                    <Link className="navbar-brand" to="/">
                                    <img src={Assets.logoMain} alt="" className="logo" />
                                    </Link> 
                                    <span className="navbar-toggle user-profile-trigger">{this.cookies.get('username')}</span>
                                </div>
                                <nav 
                                    className={(this.state.mobileMenu) ? 'navbar-collapse navbar-left collapse in' : 'navbar-collapse navbar-left collapse'} 
                                    id="navbar-collapse-left"
                                    aria-expanded={(this.state.mobileMenu) ? 'true' : 'false'}
                                    style={(this.state.mobileMenu) ? { height: 'auto' } : { height: '1px' }}
                                >
                                    {(this.cookies.get('username')) ? Body.getMenu('pull-left', Assets.mobileMenuLeft) : Body.getMenu('pull-left', Assets.mobileMenuLeftLogin)}
                                </nav>
                                <nav className="collapse navbar-collapse" id="user-profile">
                                    <ul className="nav navbar-nav navbar-right">
                                        <li className="user-nav-option">
                                            <div className="user">
                                                <div className="user-info-wrap"> <span className="user-name">{this.cookies.get('username')}</span>
                                                    <div className="balance-info"> Balance<span className="text-primary">5,000 € </span>
                                                        <a href="javascript:void(0);"><i className="icon-plus-circular"/></a>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                        {(this.cookies.get('username')) ? 
                                        <li className={(this.state.userDropdown === true) ? 'dropdown open' : 'dropdown'}>
                                            <a href="javascript:void(0);" className="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded={(this.state.userDropdown) ? 'true' : 'false'}>
                                                <i className="icon-menu-dots" onClick={() => this.setState({userDropdown: !this.state.userDropdown})}/>
                                            </a>
                                            <ul className="dropdown-menu">
                                                    <li><Link to="/myprofile"><i className="icon-profile"/>MY PROFILE</Link></li>
                                                    <li onClick={() => Utils.logout()}>
                                                    <Link to="/login">
                                                        <i className="icon-logout"/>
                                                        LOGOUT
                                                    </Link>
                                                    </li>
                                            </ul>
                                        </li>
                                        :
                                        null}
                                    </ul>
                                </nav>
                            </div>
                        </header>
                    </div>
                    <div className="info-ribbon">
                        <div className="container">
                            <div className="h4 text-center">
                                {'GAMEWEEK ' + localStorage.getItem('roundId')}
                            </div>
                        </div>
                    </div>
                    <main className="main">
                        <div className="container">
                            <div className="step-numbers">
                                <ul className="">
                                    <li className="active">
                                        <span data-li="1"><b>1</b></span>
                                        <span><b>Correct Score</b></span>
                                    </li>
                                    <li className="">
                                        <span data-li="2"><b>2</b></span>
                                        <span><b>Goal Markets</b></span>
                                    </li>
                                    <li className=" ">
                                        <span data-li="3"><b>3</b></span>
                                        <span><b>Goalscorers</b></span>
                                    </li>
                                </ul>
                            </div>
                            <h1 className="section-heading-main"> CORRECT <span className="brod-text">SCORE</span></h1>
                            <p className="text-center" style={{ fontSize: '20px', color: 'rgb(41, 160, 0)' }}>*Predict the full time result (in 90 mins) for any 3 fixtures</p>
                            <div className="listing-section">
                                {this.setMatches()}
                                <div className="clearfix" />
                                {(Main.Instance.Fantasy.chosenResults && Main.Instance.Fantasy.chosenResults.correctScores.length > 0) ?
                                <div className="possible-total">
                                    <span className="possible-total-green-background">
                                        <img src="info-white.png" onClick={() => this.setState({ checkPoints: true })}/>
                                        <b>Accumulator points</b>
                                    </span>
                                    <span className="possible-total-white-background"><b>{(possibleTotal[0] + possibleTotal[1]).toFixed(2)}</b></span>
                                </div>
                                : null}
                                <div className="row btn-wrapper mT20">
                                    {(this.props.location.state.showConfirmButton === false)
                                    ?
                                    <div>
                                        <div className="col-sm-6">
                                            <Link to={{ pathname:'/confirmation', state: { showConfirmButton: this.props.location.state.showConfirmButton } }} className="btn-default btn-lg no-shadow btn-block btn">BACK</Link>
                                        </div>
                                        <div className="col-sm-6">
                                            {(Main.Instance.Fantasy.chosenResults && Main.Instance.Fantasy.chosenResults.correctScores.length === 3) ?
                                            <Link to={{ pathname:'/confirmation', state: { showConfirmButton: this.props.location.state.showConfirmButton } }} className="btn-primary btn-lg no-shadow btn-block btn" onClick={() => updateBet(+this.cookies.get('playerId'))}>SAVE</Link>
                                            :
                                            <a
                                                className="btn-primary btn-lg no-shadow btn-block btn"
                                                onClick={() => ((!Main.Instance.Fantasy.chosenResults || (Main.Instance.Fantasy.chosenResults && Main.Instance.Fantasy.chosenResults.correctScores.length) === 0) ? alert('You haven\'t selected any match.') : alert('You have selected only ' + checkNumber('correctScores')))}
                                            >
                                            SAVE
                                            </a>}
                                        </div>
                                    </div>                           
                                    :
                                    <div className="col-sm-12">
                                        {(Main.Instance.Fantasy.chosenResults && Main.Instance.Fantasy.chosenResults.correctScores.length === 3) ?
                                        <Link 
                                            className="btn-primary btn-lg no-shadow btn-block btn"
                                            onClick={() => this.closeMatches()}
                                            to={{ pathname:'/betstep2', state: { showConfirmButton: true } }}
                                        >
                                        CONTINUE
                                        </Link>
                                        :
                                        <a
                                            className="btn-primary btn-lg no-shadow btn-block btn"
                                            onClick={() => ((!Main.Instance.Fantasy.chosenResults || (Main.Instance.Fantasy.chosenResults && Main.Instance.Fantasy.chosenResults.correctScores.length) === 0) ? alert('You haven\'t selected any match.') : alert('You have selected only ' + checkNumber('correctScores')))}
                                        >
                                        CONTINUE
                                        </a>}
                                    </div>}
                                </div>
                            </div>
                        </div>
                        {(this.state.popup) ? this.showPopup() : null}
                        {(this.state.checkPoints) ? this.showCheckPoints() : null}
                    </main>
                </section>
            )
        }
    }

    calculatePossibleTotal(bets: any) {
        if (bets) {
            let possible1X2: number = 1
            let possibleBonus: number = 1
            for (const score of bets.correctScores) {
                possible1X2 *= score.correctScore.odds1X2
                possibleBonus *= score.correctScore.bonus
            }

            return [possible1X2, possibleBonus]
        }
    }

    returnDate(i: number, match1: any, match2): JSX.Element {
        if (i == 0) {
            return <li className="header-li">{moment(match1.date).format('LL ddd')}</li>
        }
        if (i > 0 && (moment(match1.date).format('LL ddd') !== moment(match2.date).format('LL ddd'))) {
            return <li className="header-li">{moment(match1.date).format('LL ddd')}</li>
        }
    }

    setScore(position: number, result: string) {
        Main.Instance.Fantasy.selectedResult[position] = result
        Logic.Type.New(Main.Instance.Fantasy, {selectedResult: Main.Instance.Fantasy.selectedResult})
        localStorage.setItem('selectedResult', JSON.stringify(Main.Instance.Fantasy.selectedResult))
        if (Main.Instance.Fantasy.selectedResult[position][0] !== '-' && Main.Instance.Fantasy.selectedResult[position][2] !== '-') setVisible(position)
    }

    showOddsPremier(odds: any[], matchId: number, homeTeam: string, awayTeam: string, position: number): JSX.Element {
        const homeWins: any[] = []
        const draws: any[] = []
        const awayWins: any[] = []

        for (const item of odds) {
            if (+item.name[0] > +item.name[2]) homeWins.push(item)
            else if (+item.name[0] === +item.name[2]) draws.push(item)
            else if (+item.name[0] < +item.name[2]) awayWins.push(item)
        }

        const homeWinsSorted: any[] = homeWins.sort(function(a, b) {
            if (+a.name[0] === +b.name[0]) return +a.name[2] - +b.name[2]
            else return +a.name[0] - +b.name[0]
        })
        const drawsSorted: any[] = draws.sort(function(a, b) {
            if (+a.name[0] === +b.name[0]) return +a.name[2] - +b.name[2]
            else return +a.name[0] - +b.name[0]
        })
        const awayWinsSorted: any[] = awayWins.sort(function(a, b) {
            if (+a.name[0] === +b.name[0]) return +a.name[2] - +b.name[2]
            else return +a.name[0] - +b.name[0]
        })

        const homeWinsResults: JSX.Element[] = []
        const drawsResults: JSX.Element[] = []
        const awayWinsResults: JSX.Element[] = []
        
        for (const home of homeWinsSorted) {
            homeWinsResults.push(
                <div 
                    key={homeWinsResults.length} 
                    className={(home.name === Main.Instance.Fantasy.selectedResult[position]) ? 'score-and-odds-colored' : 'score-and-odds'}
                    onClick={() => {
                        this.setScore(position, home.name),
                        Utils.setCorrectScoresResult(home, matchId, homeTeam, awayTeam, position)
                    }}
                >
                    <span><b>{home.name}</b></span>
                    <span><i>{home.odds}</i></span>
                </div>
            )
        } 

        for (const draw of drawsSorted) {
            drawsResults.push(
                <div 
                    key={drawsResults.length} 
                    className={(draw.name === Main.Instance.Fantasy.selectedResult[position]) ? 'score-and-odds-draw-colored' : 'score-and-odds-draw'}
                    onClick={() => {
                        this.setScore(position, draw.name),
                        Utils.setCorrectScoresResult(draw, matchId, homeTeam, awayTeam, position)
                    }}
                >
                    <span><b>{draw.name}</b></span>
                    <span><i>{draw.odds}</i></span>
                </div>
            )
        } 

        if (screen.width > 768) {
            for (let i = draws.length; i < homeWins.length; i++) {
                drawsResults.push(
                    <div key={drawsResults.length} className="score-and-odds-draw hover-disabled">
                        <span/>
                        <span/>
                    </div>
                )
            }
        }

        for (const away of awayWinsSorted) {
            awayWinsResults.push(
                <div 
                    key={awayWinsResults.length} 
                    className={(away.name === Main.Instance.Fantasy.selectedResult[position]) ? 'score-and-odds-colored' : 'score-and-odds'}
                    onClick={() => {
                        this.setScore(position, away.name),
                        Utils.setCorrectScoresResult(away, matchId, homeTeam, awayTeam, position)
                    }}
                >
                    <span><b>{away.name}</b></span>
                    <span><i>{away.odds}</i></span>
                </div>
            )
        } 

        return (
            <div className="correctscore-third">
                <div className="correctscore-40">
                    <div className="correctscore-results">
                        <div className="team-win" onClick={() => (screen.width <= 768) ? this.updateHomeDrawAway(position, 1) : null}>
                            Team 1 to win
                        </div>
                        {(this.state.homeDrawAway[position] === 1 || this.state.homeDrawAway[position] === 4) ? 
                            <div style={{ padding: '0' }}>
                                {homeWinsResults}
                            </div> 
                        : null}
                    </div>
                </div>
                <div className="correctscore-20">
                    <div className="correctscore-results">
                        <div className="team-win-draw" onClick={() => (screen.width <= 768) ? this.updateHomeDrawAway(position, 2) : null}>Draw</div>
                        {(this.state.homeDrawAway[position] === 2 || this.state.homeDrawAway[position] === 4) ? <div style={{ padding: '0' }}>{drawsResults}</div> : null}
                    </div>
                </div>
                <div className="correctscore-40">
                    <div className="correctscore-results">
                        <div className="team-win" onClick={() => (screen.width <= 768) ? this.updateHomeDrawAway(position, 3) : null}>Team 2 to win</div>
                        {(this.state.homeDrawAway[position] === 3 || this.state.homeDrawAway[position] === 4) ? <div style={{ padding: '0' }}>{awayWinsResults}</div> : null}
                    </div>
                </div>
            </div>
        )
    }

    updateHomeDrawAway(position: number, type: number) {
        const state = this.state.homeDrawAway
        if (state[position] === type) state[position] = 0
        else state[position] = type
        this.setState({ homeDrawAway: state })
    }

    closeMatches() {
        const matches = Socket.Get<any>('matches')
        for (const match of matches.matches) {
            match.open = false
        }
        Socket.Set('matches', matches)
    }

    deleteScore(result: any) {
        if (result) {
            const index = Main.Instance.Fantasy.chosenResults.correctScores.indexOf(result)
            Main.Instance.Fantasy.chosenResults.correctScores.splice(index, 1)
            Logic.Type.New(Main.Instance.Fantasy, {chosenResults: Main.Instance.Fantasy.chosenResults})
            localStorage.setItem('chosenResults', JSON.stringify(Main.Instance.Fantasy.chosenResults))
        }
    }

    checkWin(result: any) {
        if (result.correctScore.name[0] > result.correctScore.name[2]) return 1
        else if (result.correctScore.name[0] === result.correctScore.name[2]) return 0
        else return 2
    }

    setMatches(): JSX.Element[] {
        const matchesReturn: JSX.Element[] = []
        const matches = Socket.Get<any>('matches').matches
        for (let i = 0; i < matches.length; i++) {
            const homeWin: number = (matches[i].odds.correctScore.find((elt) => elt.name === '1-0')).odds1X2.toFixed(2)
            const draw: number = (matches[i].odds.correctScore.find((elt) => elt.name === '0-0')).odds1X2.toFixed(2)
            const awayWin: number = (matches[i].odds.correctScore.find((elt) => elt.name === '0-1')).odds1X2.toFixed(2)
            const chosenResult = (Main.Instance.Fantasy.chosenResults) ? Main.Instance.Fantasy.chosenResults.correctScores.find((elt) => +elt.matchId === +matches[i].matchId && elt.correctScore.name === Main.Instance.Fantasy.selectedResult[i]) : null
            const winner = (chosenResult) ? this.checkWin(chosenResult) : null
            const utcDate = moment.utc(matches[i].date)
            matchesReturn.push(
                <ul key={i.toString()} className="versus-ul">
                    {this.returnDate(i, matches[i], matches[i - 1])}
                    <li className="content-li no-value" style={(chosenResult || matches[i].open) ? { marginBottom: '0' } : { marginBottom: '20px' }}>
                        <div className="value-reset-btn" style={{ color:'#000', top:'0px'}}>
                            <span className="match-odds" style={(winner === 1) ? { color: 'rgb(41, 160, 0)', float: 'left' } : { float: 'left' }} onClick={() => setVisible(i)}>{'To Win: ' + homeWin}</span>
                            <span className="match-odds" style={(winner === 0) ? { color: 'rgb(41, 160, 0)' } : null} onClick={() => setVisible(i)}>Draw: {draw}</span>
                            <span className="match-odds" style={(winner === 2) ? { color: 'rgb(41, 160, 0)', float: 'right', marginRight: '5px' } : { float: 'right', marginRight: '5px' }} onClick={() => setVisible(i)}>{'To Win: ' + awayWin}</span>
                        </div>
                        {(chosenResult) ?
                        <div 
                            className="reset-button" 
                            onClick={() => {this.deleteScore(chosenResult),
                                            Main.Instance.Fantasy.selectedResult[i] = '---',
                                            Logic.Type.New(Main.Instance.Fantasy, {selectedResult: Main.Instance.Fantasy.selectedResult}),
                                            localStorage.setItem('selectedResult', JSON.stringify(Main.Instance.Fantasy.selectedResult))
                            }}
                        >
                            <img src="cancel.svg" />    
                        </div>
                        : null}
                        <div className="team">
                            <span 
                                style={{ cursor: 'pointer' }} 
                                className="flag flag-lg-max"
                                onClick={() => {this.setState({ popup: true, team: matches[i].homeTeam, homeAway: 1 }), 
                                                Socket.Send('get-last-matches-info', {homeId: +matches[i].homeId, 
                                                                                        awayId: +matches[i].awayId})}}
                            >
                                <img src={'data:image/png;base64,' + matches[i].homeLogo} alt="" />
                            </span>
                            <span 
                                className="country-name" 
                                style = {{ 
                                    verticalAlign: 'middle', 
                                    cursor: 'pointer',
                                    display: 'inline-block',
                                    maxWidth: '60%',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                }}
                                onClick={() => {this.setState({ popup: true, team: matches[i].homeTeam, homeAway: 1 }), 
                                                Socket.Send('get-last-matches-info', {homeId: +matches[i].homeId, 
                                                                                        awayId: +matches[i].awayId})}}
                            >
                            {matches[i].homeTeam}
                            </span>
                            <span 
                                className="info-button"
                                onClick={() => {this.setState({ popup: true, team: matches[i].homeTeam, homeAway: 1 }), 
                                                Socket.Send('get-last-matches-info', {homeId: +matches[i].homeId, 
                                                                                        awayId: +matches[i].awayId})}}
                            >
                                <img style={{ width: '18px', height: '18px', cursor: 'pointer' }} src="info.png"/>
                                <span className="tooltip-text tooltip-text-right">View Stats</span>
                            </span>
                        </div>
                        <div className="input" onClick={() => setVisible(i)}>
                            <input className="form-control circular-input" style={{ cursor: 'pointer' }} disabled={true} placeholder={Main.Instance.Fantasy.selectedResult[i][0]/*(chosenResult) ? ((chosenResult.correctScore.name === 'Others') ? 'X' : chosenResult.correctScore.name[0]) : '-'*/}/>
                        </div>
                        <div className="match-time">{utcDate.local().format('LT')}</div>
                        <div className="input" onClick={() => setVisible(i)}>
                            <input className="form-control circular-input" style={{ cursor: 'pointer' }} disabled={true} placeholder={Main.Instance.Fantasy.selectedResult[i][2]/*(chosenResult) ? ((chosenResult.correctScore.name === 'Others') ? 'X' : chosenResult.correctScore.name[2]) : '-'*/}/>
                        </div>
                        <div className="team second-team">
                            <span 
                                style={{ cursor: 'pointer' }} 
                                className="flag flag-lg-max"
                                onClick={() => {this.setState({ popup: true, team: matches[i].awayTeam, homeAway: 2 }), 
                                                Socket.Send('get-last-matches-info', {homeId: +matches[i].homeId, 
                                                                                        awayId: +matches[i].awayId})}}
                            >
                                <img src={'data:image/png;base64,' + matches[i].awayLogo} alt="" />
                            </span>
                            <span 
                                className="info-button-right"
                                onClick={() => {this.setState({ popup: true, team: matches[i].awayTeam, homeAway: 2 }), 
                                                Socket.Send('get-last-matches-info', {homeId: +matches[i].homeId, 
                                                                                        awayId: +matches[i].awayId})}}
                            >
                                <img style={{ width: '18px', height: '18px', cursor: 'pointer' }} src="info.png"/>
                                <span className="tooltip-text tooltip-text-left">View Stats</span>
                            </span>
                            <span 
                                className="country-name"
                                style={{ 
                                    verticalAlign: 'middle', 
                                    cursor: 'pointer',
                                    display: 'inline-block',
                                    maxWidth: '60%',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                }}
                                onClick={() => {this.setState({ popup: true, team: matches[i].awayTeam, homeAway: 2 }), 
                                                Socket.Send('get-last-matches-info', {homeId: +matches[i].homeId, 
                                                                                        awayId: +matches[i].awayId})}}
                            >
                            {matches[i].awayTeam}
                            </span>
                        </div>
                        {(chosenResult) ? 
                        <div className="value-reset-btn value-reset-btn-bottom" style={{ color: 'rgb(41, 160, 0)', cursor: 'none'}}>
                            <span className="match-odds">{'Correct Score Odds: ' + chosenResult.correctScore.odds}</span>
                        </div>
                        : null}
                        
                    </li>
                    {(matches[i].open) ? this.showOddsPremier(matches[i].odds.correctScore, matches[i].matchId, matches[i].homeTeam, matches[i].awayTeam, i) : null}
                    {(chosenResult && !matches[i].open) 
                    ? 
                        <div className="chosen-result">
                            {'1X2 Points: '}<b>{chosenResult.correctScore.odds1X2.toFixed(2)}</b>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            {'Correct Score Bonus: '}<b>{chosenResult.correctScore.bonus}</b>
                        </div>
                    : 
                        null
                    }
                </ul>)
        }
    
        return matchesReturn
    }

    showPopup(): JSX.Element {
        const lastMatches = Socket.Get<any>('get-last-matches-info')
        if (lastMatches.loading !== 'loaded') {
            return <Loader/>
        } else {
            const screenPosition = document.documentElement.scrollTop + 50
            const top = screenPosition.toString() + 'px'
            const selectedLastMatches = lastMatches.teamInfo
            const logo = (this.state.homeAway === 1) ? selectedLastMatches.homeLogo : selectedLastMatches.awayLogo
            const form = (this.state.homeAway === 1) ? selectedLastMatches.homeForm : selectedLastMatches.awayForm
            const last5Home = (this.state.homeAway === 1) ? selectedLastMatches.last5HomeTeam1 : selectedLastMatches.last5HomeTeam2
            const last5Away = (this.state.homeAway === 1) ? selectedLastMatches.last5AwayTeam1 : selectedLastMatches.last5AwayTeam2
            const PLData = (this.state.homeAway === 1) ? selectedLastMatches.homePLData : selectedLastMatches.awayPLData
            return (
                <div className="popup">
                    <div className="popup-inner" style={{ top, maxHeight: '700px', overflow: 'scroll' }}>
                        <div className="team-info">
                            <div style={{ marginBottom: '20px', position: 'relative' }}>
                                <span style={{ width: '10%', marginRight: '20px' }}>
                                    <img src={'data:image/png;base64,' + logo} style={{ width: '70px', height: '60px' }}/>
                                </span>
                                <span className="team-info-name">{this.state.team.toUpperCase()}</span>
                                <span style={{ width: '10%' }} className="team-info-close"><img src="cancel.svg" style={{ width: '30px', height: '30px' }} onClick={() => this.setState({ popup: false, allMatches: false })}/></span>
                            </div>
                            <div className="team-info-form">
                                <span>Form: </span>
                                <span><img src={this.getFormIcon(form[0])}/></span>
                                <span><img src={this.getFormIcon(form[1])}/></span>
                                <span><img src={this.getFormIcon(form[2])}/></span>
                                <span><img src={this.getFormIcon(form[3])}/></span>
                                <span><img src={this.getFormIcon(form[4])}/></span>
                            </div>
                            <div className="last-matches" style={{ marginBottom: '30px' }}>
                                <p>Recent H2H Results</p>
                                {this.setLastMatches(selectedLastMatches.lastH2H)}
                            </div>
                            <div className="last-matches" style={{ marginBottom: '30px' }}>
                                <p>Recent Premier League Results</p>
                                <div className="pl-overall-info">
                                    <div>
                                        <span>Matches played:</span>
                                        <span>{PLData.matchesPlayed}</span>
                                    </div>
                                    <div>
                                        <span>Goals For:</span>
                                        <span>{PLData.goalsFor}</span>
                                    </div>
                                    <div>
                                        <span>Goals Against:</span>
                                        <span>{PLData.goalsAgainst}</span>
                                    </div>
                                    <div>
                                        <span>Clean Sheets:</span>
                                        <span>{PLData.cleanSheets}</span>
                                    </div>
                                    <div>
                                        <span onClick={() => this.setState({ allMatches: !this.state.allMatches })}>View All Matches</span>
                                    </div>
                                </div>
                                {(this.state.allMatches) ? this.setLastMatches(PLData.matches) : null}
                            </div>
                            <div className="last-matches" style={{ marginBottom: '30px' }}>
                                <p>Last 5 Home Matches</p>
                                {this.setLastMatches(last5Home)}
                            </div>
                            <div className="last-matches" style={{ marginBottom: '30px' }}>
                                <p>Last 5 Away Matches</p>
                                {this.setLastMatches(last5Away)}
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    }

    setLastMatches(matches: any): JSX.Element[] {
        const lastH2H: JSX.Element[] = []
        for (const match of matches) {
            lastH2H.push(
                <div key={lastH2H.length} style={{ background: (matches.indexOf(match) % 2 === 0) ? 'rgb(225, 225, 225)' : 'rgb(240, 240, 240)'}}>
                    <span className="last-matches-date">{match.date}</span>
                    <span className="last-matches-competition">{match.competition}</span>
                    <span className="last-matches-match">
                        <span className="last-matches-match-span">{match.homeTeam}</span>
                        <span className="last-matches-match-span"><b style={{ color: 'rgb(41, 160, 0' }}>{match.result}</b></span>
                        <span className="last-matches-match-span">{match.awayTeam}</span>
                    </span>
                </div>
            )
        }

        return lastH2H
    }

    showCheckPoints(): JSX.Element {
        const screenPosition = document.documentElement.scrollTop + 100
        const top = screenPosition.toString() + 'px'
        return (
            <div className="popup">
                <div className="popup-inner" style={{ top }}>
                    <div className="check-points-system-popup">
                        <span className="team-players-name"><b>POINTS SYSTEM</b></span>
                        <span className="team-info-close"><img src="cancel.svg" onClick={() => this.setState({ checkPoints: false })}/></span>
                    </div>      
                    <div className="check-points-system-third">
                        <h3>Correct scores</h3>
                        <p>There are two parts to the points calculation in the Correct Score predictions...</p>
                        <p>Part 1 - Correct win/draw/win (1X2) outcome = Earn the 1X2 odds for that selection, as points.</p>
                        <p>Part 2 - Correct score at full time (90mins) = Additional bonus points according to the table below;</p>
                        <p>Correct score odds 1 &#8594; 9.99 | 2 points</p>
                        <p>Correct score odds 10 &#8594; 24.99 | 3 points</p>
                        <p>Correct score odds 25+ | 5 points</p>
                        <br/>
                        <p>1X2 points are multiplied together to get the 1X2 Accumulator points.</p>
                        <p>Then, Correct Score bonus points are multiplied and the two totals are added together.</p>
                        <p>A further bonus of 3 points is awarded if the user correctly predicts the win/draw/win (1X2) outcome of all 3 selections.
                            Or, a bonus of 9 points if the user correctly predicts all 3 correct scores!</p>
                    </div>
                </div>
            </div>
        )
    }

    getFormIcon(type: string): string {
        switch(type) {
            case 'W':
                return 'win.png'
            case 'D':
                return 'draw.png'
            default:
                return 'loss.png'
        }
    }
}

interface IState2 {
    userDropdown: boolean
    popup: boolean
    team: string
    homeAway: number
    mobileMenu: boolean
    checkPoints: boolean
    allMatches: boolean
}

export class Bet2 extends React.Component<{location: {state: any}}, IState2> {
    public cookies
    
    constructor (props) {
        super(props)

        window.scroll(0, 0)

        window.onload = () => {
            Socket.Send('matches', {round: +localStorage.getItem('roundId')})
            Logic.Type.New(Main.Instance.Fantasy, {chosenResults: JSON.parse(localStorage.getItem('chosenResults'))})
            Logic.Type.New(Main.Instance.Fantasy, {selectedResult: JSON.parse(localStorage.getItem('selectedResult'))})
            if (JSON.parse(localStorage.getItem('selectedAcc')) === null) {
                Logic.Type.New(Main.Instance.Fantasy, {selectedAcc: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]})
            } else {
                Logic.Type.New(Main.Instance.Fantasy, {selectedAcc: JSON.parse(localStorage.getItem('selectedAcc'))})
            }
        }

        this.cookies = new Cookies()

        this.state = {
            userDropdown: false,
            popup: false,
            team: '',
            homeAway: 0,
            mobileMenu: false,
            checkPoints: false,
            allMatches: false
        }

        Socket.Send('flags', {})
    }

    render() {
        if (Socket.Get<any>('matches').loading !== 'loaded' || Socket.Get<any>('flags').loading !== 'loaded') {
            return <Loader/>
        } else {
            return (
                <section className="wrapper">
                    <div className="header" role="banner">
                        <header className="navbar navbar-default" style={{ marginBottom: '0' }}>
                            <div className="container">
                                <div className="navbar-header">
                                    <button 
                                        onClick={() => this.setState({ mobileMenu: !this.state.mobileMenu })}
                                        type="button" 
                                        className={(this.state.mobileMenu) ? 'navbar-toggle navbar-mid-toggle' : 'navbar-toggle navbar-mid-toggle collapsed'} 
                                        data-toggle="collapse" 
                                        data-target="#navbar-collapse-mid" 
                                        aria-expanded={(this.state.mobileMenu) ? 'true' : 'false'}
                                    >
                                    <span className="sr-only">Toggle navigation</span>
                                    <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                                    <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                                    <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                                    </button>                                  
                                    <Link className="navbar-brand" to="/">
                                    <img src={Assets.logoMain} alt="" className="logo" />
                                    </Link> 
                                    <span className="navbar-toggle user-profile-trigger">{this.cookies.get('username')}</span>
                                </div>
                                <nav 
                                    className={(this.state.mobileMenu) ? 'navbar-collapse navbar-left collapse in' : 'navbar-collapse navbar-left collapse'} 
                                    id="navbar-collapse-left"
                                    aria-expanded={(this.state.mobileMenu) ? 'true' : 'false'}
                                    style={(this.state.mobileMenu) ? { height: 'auto' } : { height: '1px' }}
                                >
                                    {(this.cookies.get('username')) ? Body.getMenu('pull-left', Assets.mobileMenuLeft) : Body.getMenu('pull-left', Assets.mobileMenuLeftLogin)}
                                </nav>
                                <nav className="collapse navbar-collapse" id="user-profile">
                                    <ul className="nav navbar-nav navbar-right">
                                        <li className="user-nav-option">
                                            <div className="user">
                                                <div className="user-info-wrap"> <span className="user-name">{this.cookies.get('username')}</span>
                                                    <div className="balance-info"> Balance<span className="text-primary">5,000 € </span>
                                                        <a href="javascript:void(0);"><i className="icon-plus-circular"/></a>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                        {(this.cookies.get('username')) ? 
                                        <li className={(this.state.userDropdown === true) ? 'dropdown open' : 'dropdown'}>
                                            <a href="javascript:void(0);" className="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded={(this.state.userDropdown) ? 'true' : 'false'}>
                                                <i className="icon-menu-dots" onClick={() => this.setState({userDropdown: !this.state.userDropdown})}/>
                                            </a>
                                            <ul className="dropdown-menu">
                                                    <li><Link to="/myprofile"><i className="icon-profile"/>MY PROFILE</Link></li>
                                                    <li onClick={() => Utils.logout()}>
                                                    <Link to="/login">
                                                        <i className="icon-logout"/>
                                                        LOGOUT
                                                    </Link>
                                                    </li>
                                            </ul>
                                        </li>
                                        :
                                        null}
                                    </ul>
                                </nav>
                            </div>
                        </header>
                    </div>
                    <div className="info-ribbon">
                        <div className="container">
                            <div className="h4 text-center">
                                {'GAMEWEEK ' + localStorage.getItem('roundId')}
                            </div>
                        </div>
                    </div>
                    <main className="main">
                        <div className="container">
                            <div className="step-numbers">
                                <ul className="">
                                    <li className="active completed">
                                        <span data-li="1"><b>1</b></span>
                                        <span><b>Correct Score</b></span>
                                    </li>
                                    <li className="active">
                                        <span data-li="2"><b>2</b></span>
                                        <span><b>Goal Markets</b></span>
                                    </li>
                                    <li className=" ">
                                        <span data-li="3"><b>3</b></span>
                                        <span><b>Goalscorers</b></span>
                                    </li>
                                </ul>
                            </div>
                            <h1 className="section-heading-main"> GOAL <span className="brod-text">MARKETS</span></h1>
                            <p className="text-center" style={{ fontSize: '20px', color: 'rgb(41, 160, 0)' }}>*Predict a goal markets outcome for any 3 fixtures</p>
                            <div className="listing-section">
                                {this.setAccumulator()}
                                <div className="clearfix" />
                                {(Main.Instance.Fantasy.chosenResults.accumulator && Main.Instance.Fantasy.chosenResults.accumulator.length > 0) ?
                                <div className="row equal-height-wrapper mB10">
                                    <div className="possible-total">
                                        <span className="possible-total-green-background">
                                            <img src="info-white.png" onClick={() => this.setState({ checkPoints: true })}/>
                                            <b>Accumulator points</b>
                                        </span>
                                        <span className="possible-total-white-background"><b>{this.calculatePossibleTotal().toFixed(2)}</b></span>
                                    </div>
                                </div>
                                : null}
                                <div className="row btn-wrapper mT20" style={{ width: '75%', margin: '0 auto' }}>
                                    {(this.props.location.state.showConfirmButton === false)
                                    ?
                                    <div>
                                        <div className="col-sm-6">
                                            <Link to={{ pathname:'/confirmation', state: { showConfirmButton: this.props.location.state.showConfirmButton } }} className="btn-default btn-lg no-shadow btn-block btn" >BACK</Link>
                                        </div> 
                                        <div className="col-sm-6">
                                            {(Main.Instance.Fantasy.chosenResults.accumulator && Main.Instance.Fantasy.chosenResults.accumulator.length === 3) ?
                                            <Link to={{ pathname:'/confirmation', state: { showConfirmButton: this.props.location.state.showConfirmButton } }} className="btn-primary btn-lg no-shadow btn-block btn" onClick={() => updateBet(+this.cookies.get('playerId'))}>SAVE</Link>
                                            :
                                            <a 
                                                className="btn-primary btn-lg no-shadow btn-block btn"
                                                onClick={() => ((Main.Instance.Fantasy.chosenResults.accumulator === undefined || Main.Instance.Fantasy.chosenResults.accumulator.length === 0) ? alert('You haven\'t selected any match.') : alert('You have selected only ' + checkNumber('accumulator')))}
                                            >
                                            SAVE
                                            </a>
                                            }
                                        </div>
                                    </div>                           
                                    :
                                    <div>
                                        <div className="col-sm-6">
                                            <Link 
                                                to={{ pathname:'/betstep1', state: { showConfirmButton: this.props.location.state.showConfirmButton } }}
                                                className="btn-default btn-lg no-shadow btn-block btn"
                                            >
                                            BACK
                                            </Link>
                                        </div>
                                        <div className="col-sm-6">
                                            {Main.Instance.Fantasy.chosenResults.accumulator && Main.Instance.Fantasy.chosenResults.accumulator.length === 3 ?
                                            <Link
                                                className="btn-primary btn-lg no-shadow btn-block btn"
                                                to={{ pathname:'/betstep3', state: { showConfirmButton: true } }}
                                            >
                                            CONTINUE
                                            </Link>
                                            :
                                            <a 
                                                className="btn-primary btn-lg no-shadow btn-block btn"
                                                onClick={() => ((Main.Instance.Fantasy.chosenResults.accumulator === undefined || Main.Instance.Fantasy.chosenResults.accumulator.length === 0) ? alert('You haven\'t selected any match.') : alert('You have selected only ' + checkNumber('accumulator')))}
                                            >
                                            CONTINUE
                                            </a>
                                            }
                                        </div>
                                    </div>}
                                </div>
                            </div>
                        </div>
                        {(this.state.popup) ? this.showPopup() : null}
                        {(this.state.checkPoints) ? this.showCheckPoints() : null}
                    </main>
                </section>
            )
        }
    }

    calculatePossibleTotal() {
        let possibleTotal: number = 1
        for (const acc of Main.Instance.Fantasy.chosenResults.accumulator) {
            possibleTotal *= acc.correctScore.odds
        }

        return possibleTotal
    }

    setAccumulator(): JSX.Element[] {
        const matchesReturn: JSX.Element[] = []
        const matches = Object.assign(Socket.Get('matches')).matches
        for (let i = 0; i < matches.length; i++) {
            matchesReturn.push(
                <div key={i.toString()} className="row equal-height-wrapper mB10">
                    <div className="equal-height-col acc-column">
                        <div className="white-box" style={{ padding: '10px' }}>
                            <div className="match-team">
                                <span 
                                    style={{ cursor: 'pointer' }} 
                                    className="flag flag-lg-max"
                                    onClick={() => {this.setState({ popup: true, team: matches[i].homeTeam, homeAway: 1 }), 
                                                    Socket.Send('get-last-matches-info', {homeId: +matches[i].homeId, 
                                                                                            awayId: +matches[i].awayId})}}
                                >
                                    <img src={'data:image/png;base64,' + matches[i].homeLogo} alt="" />
                                </span>
                                <span 
                                    className="team-name"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {this.setState({ popup: true, team: matches[i].homeTeam, homeAway: 1 }), 
                                                    Socket.Send('get-last-matches-info', {homeId: +matches[i].homeId, 
                                                                                            awayId: +matches[i].awayId})}}
                                >
                                {matches[i].homeTeam}
                                </span>
                                <span 
                                    className="info-button info-button-acc"
                                    onClick={() => {this.setState({ popup: true, team: matches[i].homeTeam, homeAway: 1 }), 
                                                    Socket.Send('get-last-matches-info', {homeId: +matches[i].homeId, 
                                                                                            awayId: +matches[i].awayId})}}
                                >
                                    <img style={{ width: '18px', height: '18px', cursor: 'pointer' }} src="info.png"/>
                                    <span className="tooltip-text tooltip-text-right">View Stats</span>
                                </span>
                            </div>
                            <div className="versus">
                                <span>vs</span>
                            </div>
                            <div className="match-team" style={{ textAlign: 'right' }}>
                                <span 
                                    className="info-button-right info-button-acc"
                                    onClick={() => {this.setState({ popup: true, team: matches[i].awayTeam, homeAway: 2 }), 
                                                    Socket.Send('get-last-matches-info', {homeId: +matches[i].homeId, 
                                                                                            awayId: +matches[i].awayId})}}
                                >
                                    <img style={{ width: '18px', height: '18px', cursor: 'pointer' }} src="info.png"/>
                                    <span className="tooltip-text tooltip-text-left">View Stats</span>
                                </span>
                                <span 
                                    className="team-name"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {this.setState({ popup: true, team: matches[i].awayTeam, homeAway: 2 }), 
                                                    Socket.Send('get-last-matches-info', {homeId: +matches[i].homeId, 
                                                                                            awayId: +matches[i].awayId})}}
                                >
                                {matches[i].awayTeam}
                                </span>
                                <span 
                                    className="flag flag-lg-max" 
                                    style={{ float: 'right', marginRight: '0', marginLeft: '20px', cursor: 'pointer' }}
                                    onClick={() => {this.setState({ popup: true, team: matches[i].awayTeam, homeAway: 2 }), 
                                                    Socket.Send('get-last-matches-info', {homeId: +matches[i].homeId, 
                                                                                            awayId: +matches[i].awayId})}}
                                >
                                    <img src={'data:image/png;base64,' + matches[i].awayLogo} alt="" />
                                </span>
                                </div>
                            <div className="checkbox-section display-table">
                                <div className="table-row">
                                    <div className={((Main.Instance.Fantasy.selectedAcc[i] === 2)) ? 'accumulator-colored' : 'accumulator'}>
                                        <a className="accumulator-name" onClick={() => { Utils.setAccumulatorOver(matches[i].odds.accumulator.over, matches[i].matchId, i, 2, matches[i].homeTeam, matches[i].awayTeam)}}><b>Over 2.5 goals</b></a>
                                        <a className="accumulator-odds" onClick={() => { Utils.setAccumulatorOver(matches[i].odds.accumulator.over, matches[i].matchId, i, 2, matches[i].homeTeam, matches[i].awayTeam)}}>
                                            <b>{matches[i].odds.accumulator.over.odds.toString()}</b>
                                        </a>
                                    </div>
                                    <div className={((Main.Instance.Fantasy.selectedAcc[i] === 3)) ? 'accumulator-colored' : 'accumulator'}>
                                        <a className="accumulator-name" onClick={() => { Utils.setAccumulatorUnder(matches[i].odds.accumulator.under, matches[i].matchId, i, 3, matches[i].homeTeam, matches[i].awayTeam)}}><b>Under 2.5 goals</b></a>
                                        <a className="accumulator-odds" onClick={() => { Utils.setAccumulatorUnder(matches[i].odds.accumulator.under, matches[i].matchId, i, 3, matches[i].homeTeam, matches[i].awayTeam)}}>
                                            <b>{matches[i].odds.accumulator.under.odds.toString()}</b>
                                        </a>
                                    </div>
                                </div>
                                <div className="table-row">
                                    <div className={(Main.Instance.Fantasy.selectedAcc[i] === 1) ? 'accumulator-colored' : 'accumulator'}>
                                        <a className="accumulator-name" onClick={() => { Utils.setAccumulatorBtts(matches[i].odds.accumulator.btts, matches[i].matchId, i, 1, matches[i].homeTeam, matches[i].awayTeam)}}><b>Both</b> <b className="mobile-hide">Teams</b> <b>to Score</b></a>
                                        <a className="accumulator-odds" onClick={() => { Utils.setAccumulatorBtts(matches[i].odds.accumulator.btts, matches[i].matchId, i, 1, matches[i].homeTeam, matches[i].awayTeam)}}>
                                            <b>{matches[i].odds.accumulator.btts.odds.toString()}</b>
                                        </a>
                                    </div>
                                    <div className={(Main.Instance.Fantasy.selectedAcc[i] === 4) ? 'accumulator-colored' : 'accumulator'}>
                                        <a className="accumulator-name" onClick={() => { Utils.setAccumulatorDraw(matches[i].odds.accumulator.draw, matches[i].matchId, i, 4, matches[i].homeTeam, matches[i].awayTeam)}}><b>Draw in 90 mins</b></a>
                                        <a className="accumulator-odds" onClick={() => { Utils.setAccumulatorDraw(matches[i].odds.accumulator.draw, matches[i].matchId, i, 4, matches[i].homeTeam, matches[i].awayTeam)}}>
                                            <b>{matches[i].odds.accumulator.draw.odds.toString()}</b>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    
        return matchesReturn
    }

    showPopup(): JSX.Element {
        const lastMatches = Socket.Get<any>('get-last-matches-info')
        if (lastMatches.loading !== 'loaded') {
            return <Loader/>
        } else {
            const screenPosition = document.documentElement.scrollTop + 50
            const top = screenPosition.toString() + 'px'
            const selectedLastMatches = lastMatches.teamInfo
            const logo = (this.state.homeAway === 1) ? selectedLastMatches.homeLogo : selectedLastMatches.awayLogo
            const form = (this.state.homeAway === 1) ? selectedLastMatches.homeForm : selectedLastMatches.awayForm
            const last5Home = (this.state.homeAway === 1) ? selectedLastMatches.last5HomeTeam1 : selectedLastMatches.last5HomeTeam2
            const last5Away = (this.state.homeAway === 1) ? selectedLastMatches.last5AwayTeam1 : selectedLastMatches.last5AwayTeam2
            const PLData = (this.state.homeAway === 1) ? selectedLastMatches.homePLData : selectedLastMatches.awayPLData
            return (
                <div className="popup">
                    <div className="popup-inner" style={{ top, maxHeight: '700px', overflow: 'scroll' }}>
                        <div className="team-info">
                            <div style={{ marginBottom: '20px', position: 'relative' }}>
                                <span style={{ width: '10%', marginRight: '20px' }}>
                                    <img src={'data:image/png;base64,' + logo} style={{ width: '70px', height: '60px' }}/>
                                </span>
                                <span className="team-info-name">{this.state.team.toUpperCase()}</span>
                                <span style={{ width: '10%' }} className="team-info-close"><img src="cancel.svg" style={{ width: '30px', height: '30px' }} onClick={() => this.setState({ popup: false, allMatches: false })}/></span>
                            </div>
                            <div className="team-info-form">
                                <span>Form: </span>
                                <span><img src={this.getFormIcon(form[0])}/></span>
                                <span><img src={this.getFormIcon(form[1])}/></span>
                                <span><img src={this.getFormIcon(form[2])}/></span>
                                <span><img src={this.getFormIcon(form[3])}/></span>
                                <span><img src={this.getFormIcon(form[4])}/></span>
                            </div>
                            <div className="last-matches" style={{ marginBottom: '30px' }}>
                                <p>Recent H2H Results</p>
                                {this.setLastMatches(selectedLastMatches.lastH2H)}
                            </div>
                            <div className="last-matches" style={{ marginBottom: '30px' }}>
                                <p>Recent Premier League Results</p>
                                <div className="pl-overall-info">
                                    <div>
                                        <span>Matches played:</span>
                                        <span>{PLData.matchesPlayed}</span>
                                    </div>
                                    <div>
                                        <span>Goals For:</span>
                                        <span>{PLData.goalsFor}</span>
                                    </div>
                                    <div>
                                        <span>Goals Against:</span>
                                        <span>{PLData.goalsAgainst}</span>
                                    </div>
                                    <div>
                                        <span>Clean Sheets:</span>
                                        <span>{PLData.cleanSheets}</span>
                                    </div>
                                    <div>
                                        <span onClick={() => this.setState({ allMatches: !this.state.allMatches })}>View All Matches</span>
                                    </div>
                                </div>
                                {(this.state.allMatches) ? this.setLastMatches(PLData.matches) : null}
                            </div>
                            <div className="last-matches" style={{ marginBottom: '30px' }}>
                                <p>Last 5 Home Matches</p>
                                {this.setLastMatches(last5Home)}
                            </div>
                            <div className="last-matches" style={{ marginBottom: '30px' }}>
                                <p>Last 5 Away Matches</p>
                                {this.setLastMatches(last5Away)}
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    }

    setLastMatches(matches: any): JSX.Element[] {
        const lastH2H: JSX.Element[] = []
        for (const match of matches) {
            lastH2H.push(
                <div key={lastH2H.length} style={{ background: (matches.indexOf(match) % 2 === 0) ? 'rgb(225, 225, 225)' : 'rgb(240, 240, 240)'}}>
                    <span className="last-matches-date">{match.date}</span>
                    <span className="last-matches-competition">{match.competition}</span>
                    <span className="last-matches-match">
                        <span className="last-matches-match-span">{match.homeTeam}</span>
                        <span className="last-matches-match-span"><b style={{ color: 'rgb(41, 160, 0' }}>{match.result}</b></span>
                        <span className="last-matches-match-span">{match.awayTeam}</span>
                    </span>
                </div>
            )
        }

        return lastH2H
    }

    showCheckPoints(): JSX.Element {
        const screenPosition = document.documentElement.scrollTop + 100
        const top = screenPosition.toString() + 'px'
        return (
            <div className="popup">
                <div className="popup-inner" style={{ top }}>
                    <div className="check-points-system-popup">
                        <span className="team-players-name"><b>POINTS SYSTEM</b></span>
                        <span className="team-info-close"><img src="cancel.svg" onClick={() => this.setState({ checkPoints: false })}/></span>
                    </div>      
                    <div className="check-points-system-third">
                        <h3>Goal markets</h3>
                        <p>User will earn the decimal odds of each correct selection, as points.
                            Points from each correct selection are multiplied together to give a Goal Markets total.</p>
                        <p>A further bonus of 3 points is awarded if the user correctly predicts a goal markets outcome in all 3 selections.</p>
                    </div>
                </div>
            </div>
        )
    }

    getFormIcon(type: string): string {
        switch(type) {
            case 'W':
                return 'win.png'
            case 'D':
                return 'draw.png'
            default:
                return 'loss.png'
        }
    }
}

interface IState3 {
    userDropdown: boolean
    popup:boolean
    player: string
    mobileMenu: boolean
    position: number
    team: number
    playerInfo: any
    checkPoints: boolean
}

export class Bet3 extends React.Component<{location: {state: any}}, IState3> {

    public cookies

    constructor(props) {
        super(props)

        window.scroll(0, 0)

        window.onload = () => {
            Socket.Send('matches', {round: +localStorage.getItem('roundId')})
            Logic.Type.New(Main.Instance.Fantasy, {chosenResults: JSON.parse(localStorage.getItem('chosenResults'))})
            Logic.Type.New(Main.Instance.Fantasy, {selectedResult: JSON.parse(localStorage.getItem('selectedResult'))})
            Logic.Type.New(Main.Instance.Fantasy, {selectedAcc: JSON.parse(localStorage.getItem('selectedAcc'))})
        }

        this.cookies = new Cookies()

        this.state = {
            userDropdown: false,
            popup: false,
            player: '',
            mobileMenu: false,
            position: 0,
            team: 0,
            playerInfo: {},
            checkPoints: false
        }

        Socket.Send('matches', {round: +localStorage.getItem('roundId')})
        Socket.Send('flags', {})
    }

    render() {
        if (Socket.Get<any>('matches').loading !== 'loaded' || Socket.Get<any>('flags').loading !== 'loaded') {
            return <Loader/>
        } else {
            return (
                <section className="wrapper">
                    <div className="header" role="banner">
                        <header className="navbar navbar-default" style={{ marginBottom: '0' }}>
                            <div className="container">
                                <div className="navbar-header">
                                    <button 
                                        onClick={() => this.setState({ mobileMenu: !this.state.mobileMenu })}
                                        type="button" 
                                        className={(this.state.mobileMenu) ? 'navbar-toggle navbar-mid-toggle' : 'navbar-toggle navbar-mid-toggle collapsed'} 
                                        data-toggle="collapse" 
                                        data-target="#navbar-collapse-mid" 
                                        aria-expanded={(this.state.mobileMenu) ? 'true' : 'false'}
                                    >
                                    <span className="sr-only">Toggle navigation</span>
                                    <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                                    <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                                    <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                                    </button>                                  
                                    <Link className="navbar-brand" to="/">
                                    <img src={Assets.logoMain} alt="" className="logo" />
                                    </Link> 
                                    <span className="navbar-toggle user-profile-trigger">{this.cookies.get('username')}</span>
                                </div>
                                <nav 
                                    className={(this.state.mobileMenu) ? 'navbar-collapse navbar-left collapse in' : 'navbar-collapse navbar-left collapse'} 
                                    id="navbar-collapse-left"
                                    aria-expanded={(this.state.mobileMenu) ? 'true' : 'false'}
                                    style={(this.state.mobileMenu) ? { height: 'auto' } : { height: '1px' }}
                                >
                                    {(this.cookies.get('username')) ? Body.getMenu('pull-left', Assets.mobileMenuLeft) : Body.getMenu('pull-left', Assets.mobileMenuLeftLogin)}
                                </nav>
                                <nav className="collapse navbar-collapse" id="user-profile">
                                    <ul className="nav navbar-nav navbar-right">
                                        <li className="user-nav-option">
                                            <div className="user">
                                                <div className="user-info-wrap"> <span className="user-name">{this.cookies.get('username')}</span>
                                                    <div className="balance-info"> Balance<span className="text-primary">5,000 € </span>
                                                        <a href="javascript:void(0);"><i className="icon-plus-circular"/></a>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                        {(this.cookies.get('username')) ? 
                                        <li className={(this.state.userDropdown === true) ? 'dropdown open' : 'dropdown'}>
                                            <a href="javascript:void(0);" className="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded={(this.state.userDropdown) ? 'true' : 'false'}>
                                                <i className="icon-menu-dots" onClick={() => this.setState({userDropdown: !this.state.userDropdown})}/>
                                            </a>
                                            <ul className="dropdown-menu">
                                                    <li><Link to="/myprofile"><i className="icon-profile"/>MY PROFILE</Link></li>
                                                    <li onClick={() => Utils.logout()}>
                                                    <Link to="/login">
                                                        <i className="icon-logout"/>
                                                        LOGOUT
                                                    </Link>
                                                    </li>
                                            </ul>
                                        </li>
                                        :
                                        null}
                                    </ul>
                                </nav>
                            </div>
                        </header>
                    </div>
                    <div className="info-ribbon">
                        <div className="container">
                            <div className="h4 text-center">
                                {'GAMEWEEK ' + localStorage.getItem('roundId')}
                            </div>
                        </div>
                    </div>
                    <main className="main">
                        <div className="container">
                            <div className="step-numbers">
                                <ul className="">
                                    <li className="active completed">
                                        <span data-li="1"><b>1</b></span>
                                        <span><b>Correct Score</b></span>
                                    </li>
                                    <li className="active completed">
                                        <span data-li="2"><b>2</b></span>
                                        <span><b>Goal Markets</b></span>
                                    </li>
                                    <li className="active ">
                                        <span data-li="3"><b>3</b></span>
                                        <span><b>Goalscorers</b></span>
                                    </li>
                                </ul>
                            </div>
                            <h1 className="section-heading-main">ANYTIME <span className="brod-text">GOALSCORERS</span></h1>
                            <p className="text-center" style={{ fontSize: '20px', color: 'rgb(41, 160, 0)' }}>*Predict any 3 players to score at any time</p>
                            <div className="listing-section">
                                {this.setGoalscorers()}
                                <div className="clearfix mT10" />
                                {(Main.Instance.Fantasy.chosenResults.goalscorers && Main.Instance.Fantasy.chosenResults.goalscorers.length > 0) ?
                                <div className="row equal-height-wrapper">
                                    <div className="possible-total">
                                        <span className="possible-total-green-background">
                                            <img src="info-white.png" onClick={() => this.setState({ checkPoints: true })}/>
                                            <b>Accumulator points</b>
                                        </span>
                                        <span className="possible-total-white-background">
                                            <b>{this.calculatePossibleTotal().toFixed(2)}</b>
                                        </span>
                                    </div>
                                </div>
                                : null}
                                <div className="row btn-wrapper mT20" style={{ width: '75%', margin: '0 auto' }}>
                                    {(this.props.location.state.showConfirmButton === false)
                                    ?
                                    <div>
                                        <div className="col-sm-6">
                                            <Link to={{ pathname:'/confirmation', state: { showConfirmButton: this.props.location.state.showConfirmButton } }} className="btn-default btn-lg no-shadow btn-block btn">BACK</Link>
                                        </div>
                                        <div className="col-sm-6">
                                            {(Main.Instance.Fantasy.chosenResults.goalscorers && Main.Instance.Fantasy.chosenResults.goalscorers.length === 3) ?
                                            <Link to={{ pathname:'/confirmation', state: { showConfirmButton: this.props.location.state.showConfirmButton } }} className="btn-primary btn-lg no-shadow btn-block btn" onClick={() => updateBet(+this.cookies.get('playerId'))}>SAVE</Link>
                                            :
                                            <a 
                                                className="btn-primary btn-lg no-shadow btn-block btn" 
                                                onClick={() => ((Main.Instance.Fantasy.chosenResults.goalscorers === undefined || Main.Instance.Fantasy.chosenResults.goalscorers.length === 0) ? alert('You haven\'t selected any goalscorer.') : alert('You have selected only ' + checkNumber('goalscorers')))}
                                            >
                                            SAVE
                                            </a>
                                            }
                                        </div>
                                    </div>                           
                                    :
                                    <div>
                                        <div className="col-sm-6">
                                            <Link 
                                                to={{ pathname:'/betstep2', state: { showConfirmButton: this.props.location.state.showConfirmButton } }}
                                                className="btn-default btn-lg no-shadow btn-block btn"
                                            >
                                            BACK
                                            </Link>
                                        </div>
                                        <div className="col-sm-6">
                                            {Main.Instance.Fantasy.chosenResults.goalscorers && Main.Instance.Fantasy.chosenResults.goalscorers.length === 3 ?
                                            <Link
                                                className="btn-primary btn-lg no-shadow btn-block btn"
                                                to={(!this.cookies.get('playerId')) ? '/login' : '/inserting'}
                                                onClick={() => this.insertBet()}
                                            >
                                            CONTINUE
                                            </Link>
                                            :
                                            <a 
                                                className="btn-primary btn-lg no-shadow btn-block btn"
                                                onClick={() => ((Main.Instance.Fantasy.chosenResults.goalscorers === undefined || Main.Instance.Fantasy.chosenResults.goalscorers.length === 0) ? alert('You haven\'t selected any goalscorer.') : alert('You have selected only ' + checkNumber('goalscorers')))}
                                            >
                                            CONTINUE
                                            </a>
                                            }
                                        </div>
                                    </div>}
                                </div>
                            </div>
                        </div>
                        {(this.state.popup) ? this.findPlayer() : null}
                        {(this.state.checkPoints) ? this.showCheckPoints() : null}
                    </main>
                </section>
            )
        }
    }

    calculatePossibleTotal() {
        let possibleTotal: number = 1
        for (const goal of Main.Instance.Fantasy.chosenResults.goalscorers) {
            if (goal.correctScore.odds < 100) possibleTotal *= goal.correctScore.odds
        }

        return possibleTotal
    }

    setGoalscorers(): JSX.Element[] {
        const goalscorersReturn: JSX.Element[] = []
        const matches = Object.assign(Socket.Get('matches')).matches
        for (let i = 0; i < matches.length; i++) {
            goalscorersReturn.push(
                <div key={i.toString()}className="row equal-height-wrapper">
                    <div className="equal-height-col goalscorers-match">
                        <div className=" advanced-versus-wrap dropdown divider display-table">
                            <div className="table-row height-100">
                                <div className={(matches[i].open === true) ? 'advanced-versus-menu table-cell vertical-mid open' : 'advanced-versus-menu table-cell vertical-mid'}>
                                    <a 
                                        className="dropdown-toggle"  
                                        data-toggle="dropdown" 
                                        role="button" 
                                        aria-haspopup="true" 
                                        aria-expanded={(matches[i].open === true) ? 'true' : 'false'}
                                        onClick={() => {setVisible(i, 1), 
                                                        Socket.Send('get-team-info', {teamId: +matches[i].homeId})
                                                        this.setState({ position: i, team: 1 })}}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <span className="flag flag-md"><img src={'data:image/png;base64,' + matches[i].homeLogo} alt=""/></span>
                                        <i className="icon-arrow-down pull-right"/>
                                        <span className="country-name">{matches[i].homeTeam}</span>
                                    </a>
                                    {(matches[i].open === true && matches[i].homeAway === 1) ? 
                                    <div className="dropdown-menu goalscorers-dropdown">
                                        {this.getMatchGoalscorers(matches[i].odds.goalscorers.homeTeam, matches[i].matchId, matches[i].homeTeam, matches[i].awayTeam, i, 1)}
                                    </div> 
                                    : null}
                                </div>
                                <div className="vs-divider vertical-mid">
                                    <span>
                                        <span style={{ zIndex: (this.state.popup || this.state.checkPoints) ? 0 : 1 }}>vs</span>
                                    </span>
                                </div>
                                <div className={(matches[i].open === true) ? 'advanced-versus-menu table-cell vertical-mid open' : 'advanced-versus-menu table-cell vertical-mid'}>
                                    <a 
                                        className="dropdown-toggle text-right" 
                                        data-toggle="dropdown" 
                                        role="button" 
                                        aria-haspopup="true" 
                                        aria-expanded={(matches[i].open === true) ? 'true' : 'false'}
                                        onClick={() => {setVisible(i, 2), 
                                                        Socket.Send('get-team-info', {teamId: +matches[i].awayId})
                                                        this.setState({ position: i, team: 2 })}}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <span className="flag flag-right flag-md"><img src={'data:image/png;base64,' + matches[i].awayLogo} alt=""/></span>
                                        <i className="pull-left icon-arrow-down"/>
                                        <span className="country-name">{matches[i].awayTeam}</span>
                                    </a>
                                    {(matches[i].open === true && matches[i].homeAway === 2) ? 
                                    <div className="dropdown-menu goalscorers-dropdown goalscorers-dropdown-away">
                                        {this.getMatchGoalscorers(matches[i].odds.goalscorers.awayTeam, matches[i].matchId, matches[i].homeTeam, matches[i].awayTeam, i, 2)}
                                    </div> 
                                    : null}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="selected-scorers selected-scorers-home">
                        {this.setSelectedScorers(matches[i].matchId, 1)}
                    </div>
                    <div className="selected-scorers selected-scorers-away">
                        {this.setSelectedScorers(matches[i].matchId, 2)}
                    </div>
                </div>
            )
        }
    
        return goalscorersReturn
    }

    getMatchGoalscorers(odds: any[], matchId: number, homeTeam: string, awayTeam: string, position: number, team: number): JSX.Element[] {
        const teamInfo = Socket.Get<any>('get-team-info')
        const matchGoalscorers: JSX.Element[] = []
        const goalscorers: any[] = []
        
        if (teamInfo.loading === 'loaded') {
            const teamSquad = teamInfo.teamInfo.squad
            // console.log('Odds: ', odds)
            // console.log('Squad: ', teamSquad)
            const sidelined = teamInfo.teamInfo.sidelined
            for (let i = 0; i < teamSquad.length; i++) {
                if (teamSquad[i].position === 'G') continue
                let oddsFound = undefined
                oddsFound = odds.find((elt) => +elt.id === +teamSquad[i].id)
                if (oddsFound) {
                    goalscorers.push({
                        id: oddsFound.id,
                        name: oddsFound.name,
                        odds: oddsFound.odds,
                        position: (teamSquad[i].position === 'A') ? 1 : (teamSquad[i].position === 'M') ? 2 : 3
                    })
                } else if (odds.length === 0) {
                    goalscorers.push({
                        id: +teamSquad[i].id,
                        name: teamSquad[i].name,
                        odds: 1,
                        position: (teamSquad[i].position === 'A') ? 1 : (teamSquad[i].position === 'M') ? 2 : 3
                    })
                }
            }

            const sortedGoalscorers = goalscorers.sort(Utils.sortF)
            for (let i = 0; i < sortedGoalscorers.length; i++) {
                
                let set: boolean = false
                if (Main.Instance.Fantasy.chosenResults.goalscorers) {
                    for (const item of Main.Instance.Fantasy.chosenResults.goalscorers) {
                        if (+item.matchId === +matchId && item.correctScore.name === sortedGoalscorers[i].name) {
                            set = true
                        }
                    }
                }
                
                if (i === 0 || (sortedGoalscorers[i - 1] && sortedGoalscorers[i - 1].position !== sortedGoalscorers[i].position)) {
                    matchGoalscorers.push(
                        <p key={matchGoalscorers.length} style={{ fontSize: '15px', marginBottom: '0' }}><b>{this.setPositionNumber(sortedGoalscorers[i].position)}</b></p>
                    )
                }

                const injured = sidelined.find((elt) => +elt.id === +sortedGoalscorers[i].id)
                if (sortedGoalscorers[i].position !== '') {
                    matchGoalscorers.push(
                        <div key={matchGoalscorers.length} className={(set === true) ? 'accumulator-colored' : 'accumulator'} style={{ width: '98%' }}>
                            <a className="accumulator-name accumulator-name-non-colored">
                                <b
                                    className={(injured) ? 'injured-color' : ''}
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {setVisible(position, team, true),
                                                    this.setState({ popup: true }),
                                                    Socket.Send('get-player-info', {playerId: +sortedGoalscorers[i].id, leagueId: 1204, competitionType: Assets.CompetitionTypes.League})}}
                                >
                                    {(sortedGoalscorers[i].name)}
                                </b>
                                <span 
                                    style={{ marginLeft: '6px', position: 'relative', bottom: '1px' }}
                                    onClick={() => {setVisible(position, team, true),
                                                    this.setState({ popup: true }),
                                                    Socket.Send('get-player-info', {playerId: +sortedGoalscorers[i].id, leagueId: 1204, competitionType: Assets.CompetitionTypes.League})}}
                                >
                                    <img src={(set === true) ? 'info-white.png' : 'info.png'}/>
                                </span>
                            </a>
                            <a 
                                className="accumulator-odds" 
                                onClick={() => {Utils.setScorers({id: +sortedGoalscorers[i].id, player: sortedGoalscorers[i].name, odds: sortedGoalscorers[i].odds, outCome: 1}, matchId, homeTeam, awayTeam, team), 
                                                setVisible(position, team)}}
                            >
                                <b>{(+sortedGoalscorers[i].odds > 1) ? sortedGoalscorers[i].odds : 'SP'}</b>
                            </a>
                        </div>
                    )
                }
            }
        }

        return matchGoalscorers
    }

    findPlayer(): JSX.Element {
        const team = Socket.Get<any>('get-team-info')
        const chosenPlayer = Socket.Get<any>('get-player-info')
        if (team.loading === 'loaded' && chosenPlayer.loading === 'loaded') {
            const playerProfile = chosenPlayer.playerInfo
            const selectedTeam = team.teamInfo
            const screenPosition = document.documentElement.scrollTop + 100
            const top = screenPosition.toString() + 'px'
            const injured = selectedTeam.sidelined.find((elt) => +elt.id === +playerProfile.playerId)
            return (
                <div className="popup">
                    <div className="popup-inner" style={{ top }}>
                        <div className="team-players">
                            <div style={{ marginBottom: '20px', position: 'relative' }}>
                                <span style={{ marginRight: '20px' }}>
                                    <img src={'data:image/png;base64,' + playerProfile.image} className="player-profile-picture"/>
                                </span>
                                <span className="team-info-name team-info-player-name">{playerProfile.name.toUpperCase()}</span>
                                <span className="team-info-close"><img src="cancel.svg" style={{ width: '30px', height: '30px' }} onClick={() => this.setState({ popup: false })}/></span>
                            </div>
                            <h3>Profile</h3>
                            <table className="team-table">
                                <thead>
                                    <tr>
                                        <th>Team</th>
                                        <th>Position</th>
                                        <th className="player-stats-hide">Age</th>
                                        <th>Club</th>
                                        <th className="player-stats-hide">Height</th>
                                        <th className="player-stats-hide">Weight</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><img src={'data:image/png;base64,' + selectedTeam.logo} className="player-team-logo"/></td>
                                        <td>{playerProfile.position}</td>
                                        <td className="player-stats-hide">{playerProfile.age}</td>
                                        <td>{playerProfile.club}</td>
                                        <td className="player-stats-hide">{playerProfile.height}</td>
                                        <td className="player-stats-hide">{playerProfile.weight}</td>
                                    </tr>
                                </tbody>
                            </table>
                            {(injured) ?
                            <div>
                                <span style={{ marginTop: '20px', fontSize: '20px', color: '#F03300'}}><b>Injury stats</b></span>
                                <div className="injury-stats">
                                    <span><b>Injury: </b><i>{injured.description}</i></span>
                                    <span><b>Injured from: </b><i>{injured.startDate}</i></span>
                                    <span><b>Expected comeback: </b><i>{(injured.endDate !== '') ? injured.endDate : 'Unknown'}</i></span>
                                </div>
                            </div>
                            : null}
                            <div>
                                {(playerProfile.thisSeasonStats) ? this.setPlayerStats(playerProfile.thisSeasonStats) : null}
                                {(playerProfile.lastSeasonStats) ? this.setPlayerStats(playerProfile.lastSeasonStats) : null}
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    }

    setPlayerStats(stats: any) {
        return (
            <div className="previous-seasons">
                <span><b>{stats.competition + ' ' + stats.season}</b></span>
                <table className="team-table">
                    <thead>
                        <tr>
                            <th>Appearances</th>
                            <th>Starts</th>
                            <th>Minutes</th>
                            <th className="player-stats-hide">Substitutes In</th>
                            <th className="player-stats-hide">Substitutes Out</th>
                            <th>Goals</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{stats.appearances}</td>
                            <td>{stats.starts}</td>
                            <td>{stats.minutes}</td>
                            <td className="player-stats-hide">{stats.substitutesin}</td>
                            <td className="player-stats-hide">{stats.substitutesout}</td>
                            <td>{stats.goals}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        )
    }

    showCheckPoints(): JSX.Element {
        const screenPosition = document.documentElement.scrollTop + 100
        const top = screenPosition.toString() + 'px'
        return (
            <div className="popup">
                <div className="popup-inner" style={{ top }}>
                    <div className="check-points-system-popup">
                        <span className="team-players-name"><b>POINTS SYSTEM</b></span>
                        <span className="team-info-close"><img src="cancel.svg" onClick={() => this.setState({ checkPoints: false })}/></span>
                    </div>      
                    <div className="check-points-system-third">
                        <h3>Goalscorers</h3>
                        <p>User will earn the decimal odds of each correct selection, as points.
                            Points from each correct selection are multiplied together to give a Goalscorers total.</p>
                        <p>A further bonus of 3 points is awarded if all three of the user´s selections score 1 goal or more.</p>
                    </div>
                </div>
            </div>
        )
    }

    checkInjury(player: string, sidelined: any) {
        for (const item of sidelined) {
            if (item.name === player) return item
        }
    }

    deleteScorer(scorer: any) {
        const index = Main.Instance.Fantasy.chosenResults.goalscorers.indexOf(scorer)
        Main.Instance.Fantasy.chosenResults.goalscorers.splice(index, 1)
        Logic.Type.New(Main.Instance.Fantasy, {chosenResults: Main.Instance.Fantasy.chosenResults})
        localStorage.setItem('chosenResults', JSON.stringify(Main.Instance.Fantasy.chosenResults))
    }

    setSelectedScorers(matchId: number, team: number): JSX.Element[] {
        const selectedScorers: JSX.Element[] = []
        const goalscorers = Main.Instance.Fantasy.chosenResults.goalscorers
        if (goalscorers) {
            for (let i = 0; i < goalscorers.length; i++) {
                if (goalscorers[i].matchId === matchId && goalscorers[i].team === team) {
                    selectedScorers.push(
                        <div className="scorer-line" key={i.toString()}>
                            <div className="name-odds">Player: <b>{goalscorers[i].correctScore.name}</b></div>
                            <div className="name-odds"><i>{'Odds: ' + ((goalscorers[i].correctScore.odds < 100) ? goalscorers[i].correctScore.odds : 'SP')}</i></div>
                            <div 
                                className="clear-button"
                                onClick={() => this.deleteScorer(goalscorers[i])}
                            >
                                <img src="cancel-white.svg"/>
                            </div>
                        </div>
                    )
                }
            }
        }

    
        return selectedScorers
    }

    insertBet() {
        if (!this.cookies.get('playerId')) {
            alert('You will need to register to enter your predictions! Click OK to go to the sign up page.')
        } else {
            const playerId = +this.cookies.get('playerId')
            const roundId = +localStorage.getItem('roundId')
            const round = /*(playerId === 52 && roundId === 8) ? 100 : */roundId
            const bet: RouteClasses.IBet = {
                playerId,
                round,
                correctScores: Main.Instance.Fantasy.chosenResults.correctScores,
                accumulator: Main.Instance.Fantasy.chosenResults.accumulator,
                goalscorers: Main.Instance.Fantasy.chosenResults.goalscorers
            }
            Socket.Send('insert-bet', bet)
        }
    }

    setPositionNumber(position: number): string {
        switch (position) {
            case 1:
                return 'Attackers'
            case 2:
                return 'Midfielders'
            default:
                return 'Defenders'
        }
      }
}

interface IStateC {
    userDropdown: boolean
    mobileMenu: boolean
    popup: boolean
    pointsSystem: number
    confirmationPopup: boolean
}

export class Confirmation extends React.Component<{location: {state: any}}, IStateC> {

    public cookies

    constructor (props) {
        super(props)

        window.scroll(0, 0)

        window.onload = () => {
            Logic.Type.New(Main.Instance.Fantasy, {chosenResults: JSON.parse(localStorage.getItem('chosenResults'))})
            Logic.Type.New(Main.Instance.Fantasy, {selectedResult: JSON.parse(localStorage.getItem('selectedResult'))})
            Logic.Type.New(Main.Instance.Fantasy, {selectedAcc: JSON.parse(localStorage.getItem('selectedAcc'))})
        }

        this.cookies = new Cookies()

        this.state = {
            userDropdown: false,
            mobileMenu: false,
            popup: false,
            pointsSystem: 0,
            confirmationPopup: this.props.location.state.showConfirmationPopup
        }

    }

    render() {
        if (!Main.Instance.Fantasy.chosenResults) {
            return <Loader/>
        } else {
            let accumulatedAccOdds: number = 1
            for (const acc of Main.Instance.Fantasy.chosenResults.accumulator) {
                accumulatedAccOdds *= acc.correctScore.odds
            }
            window.scroll(0, 0)
            return(
                <section className="wrapper">
                    <div className="header" role="banner">
                        <header className="navbar navbar-default" style={{ marginBottom: '0' }}>
                            <div className="container">
                                <div className="navbar-header">
                                    <button 
                                        onClick={() => this.setState({ mobileMenu: !this.state.mobileMenu })}
                                        type="button" 
                                        className={(this.state.mobileMenu) ? 'navbar-toggle navbar-mid-toggle' : 'navbar-toggle navbar-mid-toggle collapsed'} 
                                        data-toggle="collapse" 
                                        data-target="#navbar-collapse-mid" 
                                        aria-expanded={(this.state.mobileMenu) ? 'true' : 'false'}
                                    >
                                    <span className="sr-only">Toggle navigation</span>
                                    <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                                    <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                                    <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                                    </button>                                  
                                    <Link className="navbar-brand" to="/">
                                    <img src={Assets.logoMain} alt="" className="logo" />
                                    </Link> 
                                    <span className="navbar-toggle user-profile-trigger">{this.cookies.get('username')}</span>
                                </div>
                                <nav 
                                    className={(this.state.mobileMenu) ? 'navbar-collapse navbar-left collapse in' : 'navbar-collapse navbar-left collapse'} 
                                    id="navbar-collapse-left"
                                    aria-expanded={(this.state.mobileMenu) ? 'true' : 'false'}
                                    style={(this.state.mobileMenu) ? { height: 'auto' } : { height: '1px' }}
                                >
                                    {(this.cookies.get('username')) ? Body.getMenu('pull-left', Assets.mobileMenuLeft) : Body.getMenu('pull-left', Assets.mobileMenuLeftLogin)}
                                </nav>
                                <nav className="collapse navbar-collapse" id="user-profile">
                                    <ul className="nav navbar-nav navbar-right">
                                        <li className="user-nav-option">
                                            <div className="user">
                                                <div className="user-info-wrap"> <span className="user-name">{this.cookies.get('username')}</span>
                                                    <div className="balance-info"> Balance<span className="text-primary">5,000 € </span>
                                                        <a href="javascript:void(0);"><i className="icon-plus-circular"/></a>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                        {(this.cookies.get('username')) ? 
                                        <li className={(this.state.userDropdown === true) ? 'dropdown open' : 'dropdown'}>
                                            <a href="javascript:void(0);" className="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded={(this.state.userDropdown) ? 'true' : 'false'}>
                                                <i className="icon-menu-dots" onClick={() => this.setState({userDropdown: !this.state.userDropdown})}/>
                                            </a>
                                            <ul className="dropdown-menu">
                                                    <li><Link to="/myprofile"><i className="icon-profile"/>MY PROFILE</Link></li>
                                                    <li onClick={() => Utils.logout()}>
                                                    <Link to="/login">
                                                        <i className="icon-logout"/>
                                                        LOGOUT
                                                    </Link>
                                                    </li>
                                            </ul>
                                        </li>
                                        :
                                        null}
                                    </ul>
                                </nav>
                            </div>
                        </header>
                    </div>
                    <div className="info-ribbon">
                        <div className="container">
                            <div className="h4 text-center">
                                {'GAMEWEEK ' + localStorage.getItem('roundId')}
                            </div>
                        </div>
                    </div>
                    <main className="main">
                        <div className="container">
                            <div className="stage-view">
                                <div className="stage-view-content">
                                    <div className="stage-view-header">
                                        <div className="stage-view-row">
                                            <div className="stage-view-cell stage-view-heading">
                                                <div className="pro">
                                                    <div className="relative-wrap">
                                                        Correct Score
                                                        <Link to={{pathname:'/betstep1', state: { showConfirmButton: false } }}>
                                                            <i className="icon-pencil">&nbsp;EDIT</i>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="stage-view-cell">
                                                Predictions
                                            </div>
                                            <div className="stage-view-cell">
                                                1X2 odds
                                            </div>
                                            <div className="stage-view-cell">
                                                Score odds
                                            </div>
                                        </div>
                                    </div>
                                    <div className="stage-view-body">
                                    {this.getCorrectScores()}
                                    </div>
                                    <div className="check-points-system" onClick={() => this.setState({ popup: true, pointsSystem: 1 })}>
                                        <img src="info-black.png"/>
                                        <i>Check points system</i>
                                    </div>
                                </div>
                                <div className="stage-view-content">
                                    <div className="stage-view-header">
                                        <div className="stage-view-row">
                                            <div className="stage-view-cell stage-view-heading">
                                            <div className="pro">
                                                <div className="relative-wrap">
                                                        Goal Markets
                                                        <Link to={{pathname:'/betstep2', state:{ showConfirmButton: false } }}>
                                                            <i className="icon-pencil">&nbsp;EDIT</i>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="stage-view-cell"/>
                                            <div className="stage-view-cell"/>
                                            <div className="stage-view-cell">
                                                Odds
                                            </div>
                                        </div>
                                    </div>
                                    <div className="stage-view-body">
                                        {this.getAccumulator('Both teams to score')}
                                        {this.getAccumulator('Over 2.5 goals')}
                                        {this.getAccumulator('Under 2.5 goals')}
                                        {this.getAccumulator('Draw')}
                                        <div className="stage-view-row acc-odds-padding" style={{ background: '#E7E7E7' }}>
                                            <div className="stage-view-cell acc-odds-padding" style={{ borderBottom: '1px solid #E7E7E7' }}/>
                                            <div className="stage-view-cell acc-odds-padding" style={{ borderBottom: '1px solid #E7E7E7' }}/>
                                            <div className="stage-view-cell acc-odds-padding" data-span="Predictions" style={{ background: '#FFF' }}>
                                                Accumulator odds
                                            </div>
                                            <div className="stage-view-cell accumulated-odds-total acc-odds-padding" data-span="Odds">
                                                {accumulatedAccOdds.toFixed(2).toString()}
                                            </div>
                                        </div>
                                        <div className="stage-view-row acc-odds-padding" style={{ background: '#E7E7E7' }}>
                                            <div className="stage-view-cell acc-odds-padding" style={{ borderBottom: '1px solid #E7E7E7' }}/>
                                            <div className="stage-view-cell acc-odds-padding" style={{ borderBottom: '1px solid #E7E7E7' }}/>
                                            <div className="stage-view-cell acc-odds-padding" data-span="Predictions" style={{ background: '#FFF' }}>
                                                WHY NOT?
                                            </div>
                                            <div className="stage-view-cell place-real-money acc-odds-padding" data-span="">
                                                <a href="https://affiliates.vbet.com/links/?btag=40895" target="_blank">Go to Vbet!</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="check-points-system" onClick={() => this.setState({ popup: true, pointsSystem: 2 })}>
                                        <img src="info-black.png"/>
                                        <i>Check points system</i>
                                    </div>
                                </div>
                                <div className="stage-view-content">
                                    <div className="stage-view-header">
                                        <div className="stage-view-row">
                                            <div className="stage-view-cell stage-view-heading">
                                                <div className="pro">
                                                    <div className="relative-wrap">
                                                        Goalscorers
                                                        <Link to={{pathname:'/betstep3', state:{ showConfirmButton: false } }}>
                                                            <i className="icon-pencil">&nbsp;EDIT</i>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="stage-view-cell"/>
                                            <div className="stage-view-cell"/>
                                            <div className="stage-view-cell">
                                                Odds
                                            </div>
                                        </div>
                                    </div>
                                    <div className="stage-view-body">
                                    {this.getGoalscorers()}
                                    </div>
                                    <div className="check-points-system" onClick={() => this.setState({ popup: true, pointsSystem: 3 })}>
                                        <img src="info-black.png"/>
                                        <i>Check points system</i>
                                    </div>
                                </div>
                            </div>
                            <div className="clearfix" />
                        </div>
                        {(this.state.popup) ? this.showPopup() : null}
                        {(this.state.confirmationPopup) ? this.showConfirmationPopup() : null}
                    </main>
                </section>    
            )
        }
    }

    getCorrectScores(): JSX.Element[] {
        const scoresReturn: JSX.Element[] = []
        let accumulated1X2: number = 1
        let accumulated: number = 1
        for (const score of Main.Instance.Fantasy.chosenResults.correctScores) {
            accumulated1X2 *= score.correctScore.odds1X2
            accumulated *= score.correctScore.odds
            scoresReturn.push(
                <div key={scoresReturn.length} className="stage-view-row">
                    <div className="stage-view-cell"> {score.homeTeam}
                        <small className="text-gray vs"> vs </small>{score.awayTeam}
                    </div>
                    <div className="stage-view-cell" data-span="Predictions">
                        {score.correctScore.name[0] + '-' + score.correctScore.name[2]}
                    </div>
                    <div className="stage-view-cell" data-span="Odds1X2">
                        {score.correctScore.odds1X2.toString()}
                    </div>
                    <div className="stage-view-cell" data-span="OddsCorrectScore">
                        {score.correctScore.odds.toString()}
                    </div>
                </div>
            )
        }
        scoresReturn.push(
            <div key={scoresReturn.length} className="stage-view-row acc-odds-padding" style={{ background: '#E7E7E7' }}>
                <div className="stage-view-cell acc-odds-padding" style={{ borderBottom: '1px solid #E7E7E7' }}/>
                <div className="stage-view-cell acc-odds-padding" data-span="Predictions" style={{ background: '#FFF' }}>
                    Accumulator odds
                </div>
                <div className="stage-view-cell accumulated-odds-total acc-odds-padding" data-span="1X2 odds">
                    {accumulated1X2.toFixed(2).toString()}
                </div>
                <div className="stage-view-cell accumulated-odds-total acc-odds-padding" data-span="Score odds">
                    {accumulated.toFixed(2).toString()}
                </div>
            </div>
        )
        scoresReturn.push(
            <div key={scoresReturn.length} className="stage-view-row acc-odds-padding" style={{ background: '#E7E7E7' }}>
                <div className="stage-view-cell acc-odds-padding" style={{ borderBottom: '1px solid #E7E7E7' }}/>
                <div className="stage-view-cell acc-odds-padding" data-span="Predictions" style={{ background: '#FFF' }}>
                    WHY NOT?
                </div>
                <div className="stage-view-cell place-real-money acc-odds-padding mobile-hide" data-span="1X2 odds"/>
                <div className="stage-view-cell place-real-money acc-odds-padding" data-span="">
                    <a href="https://affiliates.vbet.com/links/?btag=40895" target="_blank">Go to Vbet!</a>
                </div>
            </div>
        )
    
        return scoresReturn                         
    }

    getAccumulator(type: string): JSX.Element[] {
        let betType: string = ''
        if (type === 'Both teams to score') betType = 'BTTS'
        else if (type === 'Over 2.5 goals') betType = 'Over'
        else if (type === 'Under 2.5 goals') betType = 'Under'
        else betType = 'Draw'

        const accReturn: JSX.Element[] = []
        const types = Main.Instance.Fantasy.chosenResults.accumulator.filter((elt) => elt.type === betType)
        if (types.length > 0) {
            accReturn.push(
                <div key = {accReturn.length} className="stage-view-row stage-view-row-alt">
                    <div className="stage-view-cell"/>
                    <div className="stage-view-cell"/>
                    <div className="stage-view-cell"/>
                    <div className="stage-view-cell-alt stage-view-cell">
                        <span data-span={type}>{type}</span>
                    </div>
                </div>
            )
            for (const res of types) {
                accReturn.push (
                    <div key = {accReturn.length} className="stage-view-row">
                        <div className="stage-view-cell"> {res.homeTeam + ' / ' + res.awayTeam} </div>
                        <div className="stage-view-cell mobile-hide"/>
                        <div className="stage-view-cell mobile-hide"/>
                        <div className="stage-view-cell" data-span="Odds">
                            {res.correctScore.odds.toFixed(2).toString()}
                        </div>
                    </div>
                )
            }
        }
        
        return accReturn
    }
    
    getGoalscorers(): JSX.Element[] {
        const goalsReturn: JSX.Element[] = []
        let accumulatedOdds: number = 1
        let noSPOdds: boolean = true
        for (const score of Main.Instance.Fantasy.chosenResults.goalscorers) {
            if (+score.correctScore.odds > 0) accumulatedOdds *= score.correctScore.odds
            if (+score.correctScore.odds === 100) noSPOdds = false
            goalsReturn.push(
                <div key={goalsReturn.length} className="stage-view-row">
                    <div className="stage-view-cell">
                        {score.correctScore.name + ' ('}<span style={(score.team !== 1) ? { color: '#AAA' } : {}}>{score.homeTeam}</span> <small className="text-gray vs"> vs </small> <span style={(score.team !== 2) ? { color: '#AAA' } : {}}>{score.awayTeam}</span>)
                    </div>
                    <div className="stage-view-cell mobile-hide"/>
                    <div className="stage-view-cell mobile-hide"/>
                    <div className="stage-view-cell" data-span="Odds">
                        {(score.correctScore.odds > 0 && score.correctScore.odds < 100) ? score.correctScore.odds.toFixed(2).toString() : 'SP'}
                    </div>
                </div>
            )
        }
        goalsReturn.push(
            <div key={goalsReturn.length} className="stage-view-row acc-odds-padding" style={{ background: '#E7E7E7' }}>
                <div className="stage-view-cell acc-odds-padding" style={{ borderBottom: '1px solid #E7E7E7' }}/>
                <div className="stage-view-cell acc-odds-padding" style={{ borderBottom: '1px solid #E7E7E7' }}/>
                <div className="stage-view-cell acc-odds-padding" data-span="Predictions" style={{ background: '#FFF' }}>
                    Accumulator odds
                </div>
                <div className="stage-view-cell accumulated-odds-total acc-odds-padding" data-span="Odds">
                    {(noSPOdds) ? accumulatedOdds.toFixed(2).toString() : 'SP'}
                </div>
            </div>
        )
        goalsReturn.push(
            <div key={goalsReturn.length} className="stage-view-row acc-odds-padding" style={{ background: '#E7E7E7' }}>
                <div className="stage-view-cell acc-odds-padding" style={{ borderBottom: '1px solid #E7E7E7' }}/>
                <div className="stage-view-cell acc-odds-padding" style={{ borderBottom: '1px solid #E7E7E7' }}/>
                <div className="stage-view-cell acc-odds-padding" data-span="Predictions" style={{ background: '#FFF' }}>
                    WHY NOT?
                </div>
                <div className="stage-view-cell place-real-money acc-odds-padding" data-span="">
                    <a href="https://affiliates.vbet.com/links/?btag=40895" target="_blank">Go to Vbet!</a>
                </div>
            </div>
        )
    
        return goalsReturn
    }

    showPopup(): JSX.Element {
        const screenPosition = document.documentElement.scrollTop + 150
        const top = screenPosition.toString() + 'px'
        return (
            <div className="popup">
                <div className="popup-inner" style={{ top }}>
                    <div className="check-points-system-popup">
                        <span className="team-players-name"><b>POINTS SYSTEM</b></span>
                        <span className="team-info-close"><img src="cancel.svg" onClick={() => this.setState({ popup: false })}/></span>
                    </div>
                    {(this.state.pointsSystem === 1) ?       
                    <div className="check-points-system-third">
                        <h3>Correct scores</h3>
                        <p>There are two parts to the points calculation in the Correct Score predictions...</p>
                        <p>Part 1 - Correct win/draw/win (1X2) outcome = Earn the 1X2 odds for that selection, as points.</p>
                        <p>Part 2 - Correct score at full time (90mins) = Additional bonus points according to the table below;</p>
                        <p>Correct score odds 1 &#8594; 9.99 | 2 points</p>
                        <p>Correct score odds 10 &#8594; 24.99 | 3 points</p>
                        <p>Correct score odds 25+ | 5 points</p>
                        <br/>
                        <p>1X2 points are multiplied together to get the 1X2 Accumulator points.</p>
                        <p>Then, Correct Score bonus points are multiplied and the two totals are added together.</p>
                        <p>A further bonus of 3 points is awarded if the user correctly predicts the win/draw/win (1X2) outcome of all 3 selections.
                            Or, a bonus of 9 points if the user correctly predicts all 3 correct scores!</p>
                    </div>
                    : (this.state.pointsSystem === 2) ?
                    <div className="check-points-system-third">
                        <h3>Goal markets</h3>
                        <p>User will earn the decimal odds of each correct selection, as points.
                            Points from each correct selection are multiplied together to give a Goal Markets total.</p>
                        <p>A further bonus of 3 points is awarded if the user correctly predicts a goal markets outcome in all 3 selections.</p>
                    </div>
                    :
                    <div className="check-points-system-third">
                        <h3>Goalscorers</h3>
                        <p>User will earn the decimal odds of each correct selection, as points.
                            Points from each correct selection are multiplied together to give a Goalscorers total.</p>
                        <p>A further bonus of 3 points is awarded if all three of the user´s selections score 1 goal or more.</p>
                    </div>
                    }
                </div>
            </div>
        )
    }

    showConfirmationPopup(): JSX.Element {
        const screenPosition = document.documentElement.scrollTop + 100
        const top = screenPosition.toString() + 'px'
        return (
            <div className="popup">
                <div className="popup-inner popup-forgot" style={{ top }}>
                    <div style={{textAlign: 'right'}}>
                        <img src="cancel.svg" style={{ width: '30px', height: '30px', cursor: 'pointer' }} onClick={() => this.setState({ confirmationPopup: false })}/>
                    </div>
                    <div className="fist-bump">
                        <img src="fist-bump.svg"/>
                    </div>
                    <p className="congratulations-second">Fair Play! Your entry has been confirmed...</p>
                    <p className="congratulations-third" style={{fontStyle: 'italic'}}>"Note": You can edit any of your selections here - Access this page from the Lounge, by clicking VIEW next to the associated Gameweek.</p>
                </div>
            </div>
        )
    }
}

export class Inserting extends React.Component<{}, {}> {

    public cookies

    constructor(props) {
        super(props)

        window.scroll(0, 0)

        this.cookies = new Cookies()
    }

    render() {
        const betInsert = Socket.Get<any>('insert-bet')
        if (betInsert.loading === 'loaded') {
            return <Redirect to={{pathname: '/confirmation', state: {showConfirmationPopup: true}}}/>
        } else {
            return <Loader/>
        }
    }
}

withCookies(Bet1, Bet2, Bet3, Confirmation, Inserting)


// WEBPACK FOOTER //
// ./src/Views/Main/Index/Bet.tsx